module.exports = __webpack_public_path__ + "static/battle05-c148eb9d006e754c5f5cb0627f9c5524.png";